<template>
  <div v-if="store.states.is_closing" class="tw-z-10 tw-absolute tw-top-0 tw-left-0 tw-h-full tw-w-full tw-bg-black tw-bg-opacity-50 tw-flex tw-items-center tw-justify-center">
    <div class="tw-rounded tw-bg-white tw-p-10 tw-text-center tw-space-y-10">
      <div class="tw-text-xl tw-font-bold md:tw-text-3xl tw-font-bold">{{$text.are_you_sure_you_want_to_leave}}</div>
      <!--<div class="tw-text-2xl tw-font-semibold">Closing this form will erase all answers you've provided!</div>-->
      <div class="tw-grid tw-grid-cols-2 tw-gap-5">

        <button v-on:click="store.close()" class="tw-flex-1 tw-rounded tw-bg-red-500 hover:tw-bg-red-600 tw-font-bold tw-text-white hover:tw-text-blue tw-px-8 tw-py-4  md:tw-text-2xl">{{$word.leave}}</button>
        <button v-on:click="store.continue()" class="tw-flex-1 tw-rounded tw-bg-secondary cursor:tw-bg-secondary-cursor tw-bg-opacity-90 hover:tw-bg-opacity-100 tw-font-bold tw-text-light tw-px-8 tw-py-4  md:tw-text-2xl">{{$word.continue}}</button>
      </div>
    </div>
  </div>
</template>
<script>
  import store from './register-store'

  export default {
    beforeCreate() {
      this.store = store
    },
    data: v => ({
      states: store.states
    })
  }
</script>
